<div class="mi-perfil-container">
  <h2>{{ miPerfil }}</h2>
  <h5>Datos generales</h5>

  <div class="perfil-container">
    <div class="perfil-left" style="position: relative;">
        <img [src]="perfil.imagenPerfilBase64" alt="Foto de perfil" class="perfil-img" 
            (error)="perfil.imagenPerfilUrl='assets/images/avatar.png'">

        <button class="btn lapiz-icon"  (click)="fileInput.click()" title="Cambiar foto">
            <i class="ti-pencil"></i>
        </button>

        <button class="btn btn-info" (click)="guardarImagen()"  *ngIf="showSavePhotoButton">
            Cambiar Foto
        </button>

       <input #fileInput type="file" id="fileInput" accept="image/*"  (change)="cambiarImagen($event)" hidden>
    </div>

    <div class="perfil-right">

        <div class="campo">
            <label>Nombre:</label>
            <span>{{ perfil.nombre }}</span>
        </div>

        <div class="campo">
            <label>Fecha de nacimiento:</label>
            <span>{{ perfil.fechaNacimiento }}</span>
        </div>

        <div class="campo">
            <label>Correo:</label>
            <span>{{ perfil.correo }}</span>
        </div>

        <div class="campo">
            <label>Rol:</label>
            <span>{{ perfil.rol }}</span>
        </div>

        <div class="campo">
            <label>Usuario:</label>
            <span>{{ perfil.login }}</span>
        </div>

        <button 
            *ngIf="!cambiandoPassword"
            class="btn btn-info"
            (click)="cambiandoPassword = true">
            <i class="ti-pencil"></i>
            Cambiar contraseña
        </button>

        <div *ngIf="cambiandoPassword" style="padding-right: 30px;">
            <div class="form-group row">
                <label class="col-sm-5 col-form-label">
                Contraseña actual:
                </label>
                <div class="col-sm-7">
                <input
                    type="password"
                    class="form-control"
                    [(ngModel)]="passwordData.OldPassword"
                    name="passwordActual" placeholder="Contraseña Actual">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-5 col-form-label">
                    Nueva contraseña: 
                    <i class="icofont icofont-info-circle" title="Políticas de contraseña: 
- La contraseña debe tener al menos 12 caracteres
- La contraseña debe contener al menos una letra mayúscula.
- La contraseña debe contener al menos una letra minúscula
- La contraseña debe contener al menos un número
- La contraseña debe contener al menos un carácter especial"></i>
                </label>
                <div class="col-sm-7">
                <input
                    type="password"
                    class="form-control"
                    [(ngModel)]="passwordData.Password"
                    name="passwordNueva" placeholder="Nueva Contraseña"
                    (input)="validatePassword(passwordData.Password, passwordData.ConfirmPassword)">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-5 col-form-label">
                Confirmar contraseña:
                </label>
                <div class="col-sm-7">
                <input
                    type="password"
                    class="form-control"
                    [(ngModel)]="passwordData.ConfirmPassword"
                    name="passwordConfirmar" placeholder="Confirmar Contraseña"
                    (input)="validatePassword(passwordData.Password, passwordData.ConfirmPassword)">
                </div>
            </div>

            <p *ngIf="!pwdValid" style="color:#ff6b6b;">{{mensajevPassword}}</p>

            <div class="text-right">
                <button class="btn btn-secondary" (click)="ocultarFormularioPassword()">
                Cancelar
                </button>
                <button class="btn btn-info" (click)="guardarPassword()" 
                [disabled]="!passwordData.Password || !passwordData.ConfirmPassword || !pwdValid">
                Guardar
                </button>
            </div>
        </div>
    </div>
</div>